<style lang="scss">
.backtotop {
    position: fixed;
    right: 10px;
    bottom: 10px;
    opacity: 0;
    a {
        display: block;
        width: 40px;
        height: 40px;
        background-color: rgba(238, 238, 238, 0.4);
        color: #333;
        &:hover {
            color: #333;
            text-decoration: none;
            background-color: rgba(238, 238, 238, 1);
        }
        span {
            display: block;
            line-height: 40px;
            text-align: center;
        }
    }
}
</style>
<script>
/*$(document).scroll(function () {
    var y = $(this).scrollTop();
    if (y > 300) {
        $('.backtotop').css({ 'opacity': '1' });
    } else {
        $('.backtotop').css({ 'opacity': '0' });
    }
});*/
</script>

<template>
<div class="home">
  <div class="backtotop">
    <a @click="scrolltoTop()" href="#pagetop"><span class="material-icons">keyboard_arrow_up</span></a>
    <!-- <router-link @click.native="$scrollToTop"><span class="material-icons">keyboard_arrow_up</span></router-link> -->
  </div>
  <Header showDescription="true" /> <!-- showDescription = Soll der Text anzeigt werden ("Hier finden sie eine Auswahl...") -->

  <b-container>
    <b-row>
      <Unternehmen />
      <Sidebar num="8" /> <!-- num = Anzahl der Items -->

    </b-row>
  </b-container>
  <Branchen />
  <Footer />
</div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Sidebar from '@/components/Sidebar/Sidebar.vue'
import Unternehmen from '@/components/Unternehmen.vue'
import Branchen from '@/components/Branchen.vue'
import Footer from '@/components/Footer.vue'


export default {
  name: 'Home',
  components: {
    Header,
    Branchen,
    Footer,
    Sidebar,
    Unternehmen
  },
  methods: {
    scrollToTop(e) {
      e.preventDefault();
      window.scrollTo(0, 0);
    }
  }
}
</script>
